let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3vKkJ")).then(() => parcelRequire('fH9y1'));